<template>
  <v-container id="agency-detail" fluid tag="section">
    <base-material-card v-if="loadAgencyDetailSuccess" icon="mdi-account-outline" class="overflow-visible pb-0 mt-0">
      <template v-slot:after-heading>
        <div class="header">
          <div v-if="$route.query.orderId" class="font-weight-light card-title mt-2">Thông tin đơn hàng</div>
          <div v-else class="font-weight-light card-title mt-2">Tạo đơn hàng</div>
        </div>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <div style="position: relative" v-if="$route.query.orderId">
          <div class="header-group-btn">
            <!-- <v-btn
              color="info"
              class="mb-2"
              @click.prevent="handleSubmit(createNewOrder)"
            >
              Sửa đơn
            </v-btn> -->

            <v-btn
              v-if="contentOrder.statusId !== 5"
              color="secondary"
              class="mb-2"
              @click="clickCancelOrder"
            >
              Huỷ đơn
            </v-btn>

            <v-btn color="success" class="mb-2" @click="clickCancel">Thoát</v-btn>
            <v-btn
              color="primary"
              class="mb-2"
              v-if="$route.query.orderId"
              @click="exportExcel($route.query.orderId)"
            >
              <v-icon>mdi-download</v-icon>Download
            </v-btn>
            <v-btn
              color="warning"
              class="mb-2"
              @click="getActiveCode"
              v-if="contentOrder.statusId !== 5 && contentOrder.statusName !== 'Đã hủy' && checkAuthorization('agency-admin_read')"
            >In mã
            </v-btn>
          </div>
        </div>
        <v-row class="px-3 active-step-3">
          <v-col class="pb-0" cols="12" md="8">
            <order-card
              :shippingAddress="shippingAddress"
              :contentOrder="contentOrder"
              :courseRegisters="courseRegisters"
              :agencyList="agencyList"
              :showChat="showChat"
            />
          </v-col>
          <v-col cols="12" md="4" class="pb-0">
            <address-card 
              :shippingAddress="shippingAddress" 
              :provinces="provinces" 
              :showChat="showChat"
              :agencyList="agencyList"
              :contentOrder="contentOrder"/>
          </v-col>
          <v-col cols="12" sm="12" style="text-align: center;" v-if="!$route.query.orderId">
            <v-btn
              color="success"
              class="mb-3"
              @click="checkValidate"
              @click.prevent="handleSubmit(createNewOrder); scrollToError('v-messages__message', 'order-products-wrapper')"
            >Tạo đơn</v-btn>
            <v-btn color="primary" class="mb-3" @click="clickCancel">Huỷ bỏ</v-btn>
          </v-col>
        </v-row>
      </validation-observer>
    </base-material-card>

    <order-dialog
      :loading="loadingCreateOrder"
      :dialog="createDialog" 
      :courseRegisters="courseRegisters" 
      @closeModal="closeModal"
      :dataDialog="dataDialog"
      :provinces="provinces"
      :checkEndDate="checkEndDate"
      @orderAction="clickCreateOrder"/>
  </v-container>
</template>

<script>
import TokenService from '../../../helpers/token';
import AddressCard from './AddressCard';
import OrderCard from './OrderCard';
import OrderDialog from './OrderDialog';
import RepositoryFactory from '../../../repositories/RepositoryFactory';
import { downloadFile } from '../../../helpers/utils';
import * as moment from 'moment'
const AgencyRepository = RepositoryFactory.get('agency');
const ProductRepository = RepositoryFactory.get('product');
const AddressRepository = RepositoryFactory.get('address');
const OrderRepository = RepositoryFactory.get('order');

export default {
  components: { AddressCard, OrderCard, OrderDialog },
  data() {
    return {
      courseRegisters: [],
      dataForm: {
        customers: [{}]
      },
      dataFormOld: '',
      mainCustomer: {},
      stepOrder: 1,
      firstStep: false,
      provinces: [],
      shippingAddress: {
        receiver: '',
        phone: '',
        tinhId: 0,
        xaid: 0,
        huyenId: 0,
        detailAddress: ''
      },
      contentOrder: {
        paidAmount: 0,
        totalPrice: 0,
        discount: 0,
        products: [
          {
            productId: '',
            quantity: 1,
            price: 0,
            agencyId: '',
            productType: '',
            name: '',
            endDate: '',
            code: '',
            endMonth: ''
          }
        ],
        description: '', //ghi chu don hang,
        paymentType: ''
      },
      loadAgencyDetailSuccess: false,
      showChat: false,
      dataUpdate: {},
      dataDialog: {},
      createDialog: false,
      checkEndDate: true,
      loadingCreateOrder: false,
      agencyList: []
    };
  },
  computed: {},
  created() {
    let self = this
    self.getAgencyDetail();
    self.getProvinces();
    self.getProductComboList();
    // self.beforeCreate();
    self.contentOrder = {
      paidAmount: 0,
      totalPrice: 0,
      discount: 0,
      products: [
        {
          productId: '',
          quantity: 1,
          price: 0,
          agencyId: '',
          productType: '',
          name: '',
          endDate: '',
          code: ''
        }
      ],
      description: '', //ghi chu don hang,
      paymentType: ''
    };
  },
  beforeDestroy() {},
  methods: {
    clickCancel() {
      if (history.back()) {
        history.back()
      } else {
        this.$router.push({
          name: 'DetailAgency',
          params: {
            id: this.$route.params.id || 0
          },
          query: {
            tabIndex: 1
          }
        });
      }
    },
    async clickCreateOrder() {
      this.closeModal()
      // Combine the same products and customers
      this.loading = this.$loading.show();
      this.loadingCreateOrder = true;
      // delete this.dataUpdate.listEndDate;
      const response = await OrderRepository.create(this.dataUpdate);
      this.loading.hide();
      this.loadingCreateOrder = false;
      if (response.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      } else if (_.get(response, 'data.isExist', false)) {
        this.$swal({
          title: 'Thêm mới đơn hàng không thành công, Số điện thoại đại lý đã tồn tại!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Xem đại lý',
          closeOnConfirm: false,
          cancelButtonText: 'Huỷ Bỏ'
        }).then(result => {
          if (result.value) {
            return this.$router.push({
              name: 'AgencyDetail',
              params: {
                id: _.get(response, 'data.agencyId', null)
              }
            });
          }
        });
      } else {
        this.$swal({
          title: 'Tạo Đơn hàng thành công!',
          confirmButtonText: 'Đồng ý'
        }).then(() => {
          this.$router.push({
            name: 'AgencyOrderList',
            params: {
              id: this.$route.params.id
            }
          });
        });
      }
    },
    async getProvinces() {
      const respond = await AddressRepository.provinces({ limit: 100 });
      if (_.get(respond, 'success', false)) {
        this.provinces = _.get(respond, 'data', []).filter(
          data => data.id != 0
        );
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async getAgencyList () {
      const params = {
        limit: 50,
        page: 0
      }
      const loader = this.$loading.show()
      const response = await AgencyRepository.list(params)
      loader.hide()
      if (response.success) {
        this.agencyList = _.get(response, 'data', [])
      }
    },
    async getAgencyDetail() {
      let self = this
      // lay thong tin san pham neu xem chi tiet don hang
      if (self.$route.query.orderId) {
        const res = await AgencyRepository.getOrderDetail(self.$route.query.orderId);
        if (res.success) {
          let listOrder = _.get(res, 'data', {})
          self.contentOrder = {
            paidAmount: listOrder.paidAmount,
            totalPrice: listOrder.totalPrice,
            discount: listOrder.discount,
            products: listOrder.products,
            description: listOrder.description, //ghi chu don hang,
            paymentType: listOrder.paymentType,
            statusId: listOrder.statusId
          };
          self.contentOrder.products.forEach(item => {
            item.productId = item.id
          })
        }
      }
      
      // lay thong tin dai ly
      const loader = self.$loading.show();
      const respond = await AgencyRepository.detail(self.$route.params.id);
      loader.hide();
      if (_.get(respond, 'success', false) && _.get(respond, 'data', null)) {
        self.loadAgencyDetailSuccess = true
        const dataAgency = _.get(respond, 'data', {});
        self.shippingAddress = dataAgency;
        self.shippingAddress.receiver = dataAgency.name
        self.getAgencyList()
        const groupIds = [];
        if (!Array.isArray(dataAgency.customers)) {
          dataAgency.customers = [];
        }
        const customers = dataAgency.customers.map(customer => {
          const customerTemp = customer;
          customerTemp.agencyId = customerTemp.id;
          customerTemp.phones = _.get(customer, 'phones', []).map(
            data => data.phoneNumber
          );
          customerTemp.courseRegister = [];
          customerTemp.combos.forEach(combo => {
            customerTemp.courseRegister.push(`combo-${combo.id}`);
            _.get(combo, 'products', []).forEach(product => {
              if (
                _.get(product, 'group.id', null) &&
                !groupIds.includes(product.group.id)
              )
                groupIds.push(product.group.id);
            });
          });
          customerTemp.products.forEach(product => {
            customerTemp.courseRegister.push(`product-${product.id}`);
            if (
              _.get(product, 'group.id', null) &&
              !groupIds.includes(product.group.id)
            )
              groupIds.push(product.group.id);
          });

          if (!_.get(customer, 'isMainCustomer', false)) {
            if (!Array.isArray(customerTemp.phones)) {
              customerTemp.phones = [];
            }
            customerTemp.mobile = _.get(customerTemp, 'phones[0]', '');
            customerTemp.phones.shift();
          }

          customerTemp.isNew = false;

          if (customer.isMainCustomer && customer.fullName === '') {
            customerTemp.fullName = customerTemp.mobile;
          }

          return customerTemp;
        });

        const mainCustomer = customers.find(
          customer => customer.isMainCustomer
        ) || {
          mobile: '',
          isMainCustomer: true,
          position: 'other',
          phones: [],
          courseRegister: []
        };

        const customersTemp = [
          mainCustomer,
          ...customers.filter(customer => !customer.isMainCustomer)
        ];


        self.dataForm = {
          ...dataAgency,
          groupIds,
          customers: customersTemp,
        };
        self.dataFormOld = JSON.stringify(self.dataForm);
      } else {

      }
    },
    async getProductComboList() {
      const respond = await ProductRepository.listAll({ limit: 100, moduleType: 10 });
      if (_.get(respond, 'success', false)) {
        const products = _.get(respond, 'data.products', []).map(product => {
          const productTemp = product;
          // productTemp.idTemp = `product-${product.id}`;
          return productTemp;
        });
        const combos = _.get(respond, 'data.combos', []).map(combo => {
          const comboTemp = combo;
          // comboTemp.idTemp = `combo-${combo.id}`;
          comboTemp.price = _.get(comboTemp, 'products', []).reduce(
            (accumulator, product) => {
              return accumulator + _.get(product, 'price', 0);
            },
            0
          );
          return comboTemp;
        });
        this.courseRegisters = [
          { header: 'Sản Phẩm' },
          ...products
        ];
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async clickCancelOrder() {
      this.$swal({
          title: 'Huỷ đơn hàng',
          text: 'Bạn có thực sự muốn huỷ đơn hàng ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
          closeOnClickOutside: false,
          allowOutsideClick: false
        }).then(async (result) => {
          if (!result.value) {
            return;
          }
          const shipping = {
            tinhId: _.get(this.shippingAddress, 'tinhId', ''),
            huyenId: _.get(this.shippingAddress, 'huyenId', ''),
            xaId: _.get(this.shippingAddress, 'xaId', ''),
            detailAddress: _.trim(this.shippingAddress.detailAddress)
          };
          let data = {
            shippingAddress: shipping,
            statusId: 5
          }
          const loader = this.$loading.show();
          const response = await AgencyRepository.updateOrder(this.$route.query.orderId, data)
          loader.hide()
          if (response.error) {
              this.$swal({
                  type: 'error',
                  title: 'Lỗi !',
                  text: _.get(response, 'message', '')
              });
          } else {
              this.$swal({
                  title: 'Huỷ đơn hàng thành công!',
                  confirmButtonText: 'Đồng ý',
              }).then(() => {
                  window.location.href = '/agency/detail/'+ this.$route.params.id+ '?tabIndex=1'
              });
          }
        })
    },
    async beforeCreate() {
      let objectCheckProducts = {};
      const productsTemp = [];
      let indexProductsTemp = 0;
      _.get(this.contentOrder, 'products', []).forEach(product => {
        const idTemp = product.productId + '_' + product.agencyId;
        const indexTemp = objectCheckProducts[idTemp];
        if (indexTemp == null) {
          objectCheckProducts[idTemp] = indexProductsTemp;
          indexProductsTemp++;
          productsTemp.push({ ...product });
        } else {
          productsTemp[indexTemp].quantity += +product.quantity;
        }
      });
      this.contentOrder.totalPrice = productsTemp.reduce((accumulator, product) => {return accumulator + _.get(product, 'price', 0) * _.get(product, 'quantity', 0)}, 0) || 0
      // End Combine the same products and customers
      this.contentOrder.products = productsTemp;
    },
    checkValidate() {
      let array = this.contentOrder.products
      array.forEach(i => {
        if(i.productId === '' || i.productId === null) {
          this.$swal({
            type: 'error',
            title: 'Lỗi!',
            text: 'Chưa thêm sản phẩm cho đơn hàng'
          });
        }
        return
      })
    },
    async createNewOrder() {
      const contentOrderUpdate = {
        description: _.trim(this.contentOrder.description),
        paymentType: this.contentOrder.paymentType,
        paidAmount: !this.contentOrder.paidAmount
          ? 0
          : Number(this.contentOrder.paidAmount),
        totalPrice: 0,
        discount: !this.contentOrder.discount
          ? 0
          : Number(this.contentOrder.discount),
      };
      const shippingAddressUpdate = {
        receiver: _.trim(this.shippingAddress.receiver),
        phone: _.get(this.shippingAddress, 'phone', ''),
        tinhId: _.get(this.shippingAddress, 'tinhId', ''),
        huyenId: _.get(this.shippingAddress, 'huyenId', ''),
        xaId: _.get(this.shippingAddress, 'xaId', ''),
        detailAddress: _.trim(this.shippingAddress.detailAddress)
      };
      // Gộp các sản phẩm trùng nhau
      const productsTemp = [];
      _.get(this.contentOrder, 'products', []).forEach(product => {
        let indexItem = productsTemp.findIndex(prod => prod.productId == product.productId)
        if (indexItem <= -1) {
          productsTemp.push({ ...product });
        } else {
          productsTemp[indexItem].quantity = (+productsTemp[indexItem].quantity) + (+product.quantity);
        }
      });
      this.contentOrder.products = productsTemp;

      contentOrderUpdate.products = this.contentOrder.products.map(product => {
        contentOrderUpdate.totalPrice += product.price*product.quantity;
        return {
          productId: +product.productId,
          productType: product.productType,
          quantity: +product.quantity,
          agencyId: +product.agencyId,
          price: product.price,
          code: product.code,
          name: product.name,
          endDate: product.endDate,
          endMonth: product.endMonth
        };
      });
      const dataUpdate = {
        agencyId: this.$route.params.id,
        paymentType: _.get(contentOrderUpdate, 'paymentType', 'BANK'),
        description: _.trim(contentOrderUpdate.description),
        paidAmount: +_.get(contentOrderUpdate, 'paidAmount', 0),
        totalPrice: +_.get(contentOrderUpdate, 'totalPrice', 0),
        discount: +_.get(contentOrderUpdate, 'discount', 0),
        products: _.get(contentOrderUpdate, 'products', []),
        shippingAddress: shippingAddressUpdate,
      };
      this.dataUpdate = dataUpdate

      this.dataDialog = {
        statusId: this.contentOrder.statusId,
        ...dataUpdate,
      }
      this.createDialog = true
    },
    closeModal() {
      this.createDialog = false
    },
    async exportExcel(id) {
      let self = this
      self.appLoadingData(true);
      const res = await AgencyRepository.exportActiveCodeForOrder(id);
      self.appLoadingData(false)
      if (res.data && res.data.success) {
        self.$swal({
          text: 'Đã tải xuống danh sách mã kích hoạt của đơn hàng!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        })
        await downloadFile(_.get(res, 'data.data.csvFile', ''), _.get(res, 'data.data.fileName', ''));
      } else {
        self.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
      }
    },
    async getActiveCode() {
      let activeCodeList = []
      const params = {
        agencyId: this.$route.params.id,
        orderAgencyId: this.$route.query.orderId,
        typeOfCode: 2, // Mã đại lý
        page: 0,
        limit: 1000
      }
      const res = await AgencyRepository.listActiveCode(params)
      if (res.success) {
        activeCodeList = _.get(res, 'data', [])
        this.printActiveCode(activeCodeList)
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    },
    initWindowPrint() {
      let mywindow = window.open();
      mywindow.document.write('<html><head><title>In_ma_'+moment(new Date()).format("DD-MM-YYYY HH:mm:ss")
        +'</title><style></style><link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900"></head><body style="margin:0 !important">');
      return mywindow;
    },
    endWindowPrint(mywindow, html) {
      mywindow.document.write(html);
      mywindow.document.write('</body></html>');
      mywindow.document.querySelector('style').textContent += `
        @media print{
          @page{
            size: a4 landscape;margin:0
          }
        }
      `
      mywindow.document.close(); // necessary for IE >= 10 
      mywindow.focus(); // necessary for IE >= 10*/
      mywindow.print();
      mywindow.close();
      return true;
    },
    printActiveCode(activeCode) {
      var html = ""

      if (activeCode.length > 0) {
        var mywindow = this.initWindowPrint()
        activeCode.forEach((item,key) => {
          if (item.status !== 'inactive') {
            html += '<div class="page" id="printSection" style="font-family:Roboto,sans-serif;width:297mm;height:209mm">';
            html += '<h2 style="padding-top:67mm;padding-left:32px;font-size:27px"><b>MÃ KÍCH HOẠT - '
              +item.numberOfSubject+ ' MÔN</b></h2>';
            html += '<h1 style="padding-top:5mm;padding-left:80px"><b>' + item.activeCode + '</b></h1>';
            html += '<p style="padding-left:27px;font-size:15px">*Thời gian học kể từ ngày kích hoạt: '
              +item.studyTimeText+'</p>';
            html += '<p style="padding-top:90mm;padding-left:10px">'+(parseInt(key)+1)+'</p></div>'
          }
        })
        this.endWindowPrint(mywindow, html)
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Đơn không có mã hoặc đã hủy'
        });
      }
    }
  }
};
</script>
<style lang="sass">
  .active-step-3
    .sort-order
      order: 2

</style>
